export const outOfPolicyStatus = {
    WithinPolicy: 0,
    InPolicyWithWarning: 1,
    InPolicyWithWarningAndJustification: 2,
    OutOfPolicyBookingAllowed: 3,
    OutOfPolicyBookingAllowedWithJustification: 4,
    OutOfPolicyBookingProhibited: 5,
};



// WEBPACK FOOTER //
// ./src/app/modules/common/enum/out-of-policy-status-enum.js